import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Button, Title } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import * as React from 'react';
import { findFirst } from "../../../../utils/arrays";
import SuccessStatus from "./assets/success.svg";
import ErrorStatus from "./assets/error.svg";
import WarningStatus from "./assets/warning.svg";
import { LogoButton } from "../../HeaderButtons/LogoButton";
import { ModalLayout } from "../../ModalLayout";
import styles from "./styles.pcss";
import { EResult } from "./types";
var cn = classNames.bind(styles);
export var ModalResult = function ModalResult(_ref) {
  var result = _ref.result,
    title = _ref.title,
    subtitle = _ref.subtitle,
    submitButtonProps = _ref.submitButtonProps,
    cancelButtonProps = _ref.cancelButtonProps,
    _ref$Component = _ref.Component,
    ButtonComponent = _ref$Component === void 0 ? Button : _ref$Component;
  return /*#__PURE__*/React.createElement(ModalLayout, {
    className: cn('wrapper')
  }, /*#__PURE__*/React.createElement(ModalLayout.Header, null, /*#__PURE__*/React.createElement(LogoButton, null)), /*#__PURE__*/React.createElement(ModalLayout.Content, null, /*#__PURE__*/React.createElement("div", {
    className: cn('content')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('circle', _defineProperty({}, result, Boolean(result)))
  }, result === EResult.Success && /*#__PURE__*/React.createElement(SuccessStatus, null), result === EResult.Error && /*#__PURE__*/React.createElement(ErrorStatus, null), result === EResult.Warning && /*#__PURE__*/React.createElement(WarningStatus, null), result === EResult.PaymentFailure && /*#__PURE__*/React.createElement(ErrorStatus, null)), /*#__PURE__*/React.createElement(Title, {
    className: cn('title'),
    size: findFirst([(!subtitle || result === EResult.Error) && 's', 'm']),
    subTitle: subtitle,
    title: title
  }))), /*#__PURE__*/React.createElement(ModalLayout.Buttons, null, /*#__PURE__*/React.createElement(ButtonComponent, _extends({}, submitButtonProps, {
    size: "l",
    view: "primary",
    width: "full"
  })), cancelButtonProps && /*#__PURE__*/React.createElement(ButtonComponent, _extends({}, cancelButtonProps, {
    size: "l",
    view: "secondary",
    width: "full"
  }))));
};